import httpClient from '../httpClient.js';

const API_REQUEST_REPORT_LOADER = {
    ENDPOINT: '/ModaNet/Report/ReportLoader.aspx?',
    SIGN: { 
        action: 'required:string',
        menuid: 'string',
        nomasterpage: 'default=1'
    }
}

const getReport = () => httpClient.get(API_REQUEST_REPORT_LOADER)
const getReportFromPath = (path) => httpClient.simpleGet(path)

export {
    getReport, getReportFromPath
} 